import { type GridColDef } from "@mui/x-data-grid";

import { ExpandedEcrAssignmentRow } from "api/memberPortal/reports/expandedEcrAssignment/expandedEcrAssignment.types";
import { calculateActiveDaysInProgress } from "utils/timeUtils";

import ConformanceClaimsCell from "./cells/ConformanceClaims.cell";
import NotesCell from "./cells/Notes.cell";
import ProgressPointsCell from "./cells/ProgressPoints.cell";
import ProjectTeamCell from "./cells/ProjectTeam.cell";
import TechTypeCell from "./cells/TechTypes.cell";

export const ExpandedEcrAssignmentReportColumns: GridColDef<ExpandedEcrAssignmentRow>[] =
  [
    {
      field: "v_id",
      headerName: "VID",
      flex: 0.8,
      minWidth: 80,
      maxWidth: 100,
      renderCell: ({ row }) => {
        const { v_id, product_id } = row;
        return (
          v_id && (
            <a href={`/community/products/details/${product_id}`}>{v_id}</a>
          )
        );
      },
    },
    {
      field: "assigned_lab",
      headerName: "Lab",
      flex: 0.8,
      minWidth: 80,
      maxWidth: 100,
    },
    {
      field: "project_team",
      headerName: "Project Team",
      flex: 1.5,
      minWidth: 130,
      maxWidth: 250,
      sortable: false,
      renderCell: ({ row }) => <ProjectTeamCell row={row} />,
    },
    {
      field: "conformance_claims",
      headerName: "Conformance",
      flex: 1.5,
      minWidth: 110,
      maxWidth: 200,
      sortable: false,
      renderCell: ({ row }) => <ConformanceClaimsCell row={row} />,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.8,
      minWidth: 90,
      maxWidth: 120,
    },
    {
      field: "tech_type",
      headerName: "Tech Types",
      flex: 0.8,
      minWidth: 90,
      maxWidth: 120,
      renderCell: ({ row }) => <TechTypeCell row={row} />,
    },
    {
      field: "progress_points",
      headerName: "Progress Points",
      flex: 3,
      minWidth: 200,
      maxWidth: 450,
      sortable: false,
      renderCell: ({ row }) => <ProgressPointsCell row={row} />,
    },
    {
      field: "days_in_progress",
      headerName: "Days in Progress",
      flex: 1,
      minWidth: 100,
      maxWidth: 150,
      renderCell: ({ row }) => calculateActiveDaysInProgress(row),
    },
    {
      field: "latest_note",
      headerName: "Latest Note",
      flex: 2,
      minWidth: 200,
      sortable: false,
      renderCell: ({ row }) => <NotesCell row={row} />,
    },
  ];
